import { useEffect } from 'react';

import { trackPageView } from '@lib';
import { DOCUMENT_TITLE } from '@configs';

const useScreenTracker = (pageTitle?: string) => {
  useEffect(() => {
    if (pageTitle === undefined) return;

    trackPageView({ title: pageTitle });
    document.title = `${DOCUMENT_TITLE}${pageTitle ? ` | ${pageTitle}` : ''}`;
  }, [pageTitle]);
};

export default useScreenTracker;
